// Explicit simulation world container (Fase 1 headless core).
// Wraps the legacy singleton buffers (G, rooms, map) without changing rules.

import { G, rooms, map } from './state';
import type { Room } from './types';
import { createEntityStore, type EntityStore } from './entity';

export interface RngState {
  state: number;
}

export interface MapBuffers {
  w: number;
  h: number;
  m: Uint8Array;
  r: Int32Array;
  totalRooms: number;
}

export type GameScalars = typeof G;

export interface World {
  g: GameScalars;
  rooms: Room[];
  map: MapBuffers;
  rng: RngState;
  entities: EntityStore;
}

let activeWorld: World | null = null;

export function createWorld(seed = 1): World {
  const s = (seed >>> 0) || 1;
  const world: World = {
    g: G,
    rooms,
    map,
    rng: { state: s },
    entities: createEntityStore(),
  };
  activeWorld = world;
  G.seed = s;
  return world;
}

export function getActiveWorld(): World {
  if (!activeWorld) return createWorld(G.seed);
  return activeWorld;
}

export function setActiveWorld(world: World): void {
  activeWorld = world;
  G.seed = world.rng.state;
}

export function snapshotRng(world: World): void {
  world.rng.state = world.rng.state >>> 0;
  world.g.seed = world.rng.state;
}
